var brands = {

	closed: $('.brands-list-link-with-tooltip'),

	tooltipPos: function() {
		brands.closed.each(function() {
			var _this = $(this);
			var size = _this.text().length;
			var wrapper = _this.closest('.brands-list-item');
			var tooltip = wrapper.find('.tooltip-content');
			console.log(_this.text(), size, size < 5, size > 16);
			if (size < 5) {
				tooltip.addClass('tooltip-text-short');
			} else if (size > 16) {
				tooltip.addClass('tooltip-text-long');
			}
		});
	},

	wrapperEl: $('.brands-list-link .tooltip-wrapper'),
	triggerEl: $('.brands-list-link .tooltip-trigger'),
	contentEl: $('.brands-list-link .tooltip-content'),

	showHide: function() {
		if (!isTouch) {
			brands.triggerEl.hover(
				function(){
					$(this).closest(brands.wrapperEl).find(brands.contentEl).fadeToggle();
					brands.triggerEl.not($(this)).closest(brands.wrapperEl).find(brands.contentEl).fadeOut();
				},
				function(){
					brands.contentEl.fadeOut();
				}
			);
		}
	},

	init: function() {
		if (brands.closed.length) {
			brands.tooltipPos();
			brands.showHide();
		}
	}
};
